import { useState, useEffect } from "react";

const useFilePath = (filePath, defaultPath = null) => {
  const [validFilePath, setValidFilePath] = useState(null);

  useEffect(() => {
    const checkFileExists = (path) => {
      return fetch(path, { method: "HEAD" })
        .then((response) => 
          // Verifica si la respuesta es 200 y si el Content-Type no es html (Azure devuelve 200 aunque el archivo no exista pero con content-type text/html)
          response.ok && response.headers.get("Content-Type") !== "text/html" ? path : null
        )
        .catch(() => null);
    };

    const checkFiles = async () => {
      const validPath = (await checkFileExists(filePath)) || (await checkFileExists(defaultPath)) || null;
      setValidFilePath(validPath);
    };

    checkFiles();
  }, [filePath, defaultPath]);

  return validFilePath;
};

export default useFilePath;
